export default "__VITE_ASSET__BwBihyNH__"